/**
 * Версии юридических документов для фиксации согласия в Firestore.
 * Порядок обновления текстов и версий — см. Docs/3_Features/legal-user-consent-and-compliance-tasks.md §4.1.
 */
export const LEGAL_TERMS_VERSION = '2026-03-29';

export const LEGAL_PRIVACY_VERSION = '2026-03-29';
